
import { Component, Vue, Emit } from 'vue-property-decorator';
import {
  CardButtons,
  ActionButtonList
} from '@/modules/common/components/cards/CardButtons';

@Component({
  components: { CardButtons }
})
export default class SuggestedTransactionCard extends Vue {
  button: ActionButtonList[] = [
    {
      label: 'Ver Agora',
      action: 'onClick',
      testId: 'suggested-transaction-card'
    }
  ];

  @Emit('open')
  open() {}
}
